// extracted by css-extract-rspack-plugin
export default {"legend":"np6iOY5yro2UAMtn","item":"F4ZjMXvgQoIzTbHY","unselected":"SjRJj2vMCYgUzjMY","dot":"KA4H5Nhw3QBCSNT_"};